/** OPFS blob cache (spec §8.10 step 3, §16): `blobs/<hash>`. Falls back to memory when OPFS is unavailable. */
const mem = new Map<string, Blob>();

async function dir(): Promise<FileSystemDirectoryHandle | null> {
  try {
    const root = await navigator.storage.getDirectory();
    return await root.getDirectoryHandle("blobs", { create: true });
  } catch {
    return null;
  }
}

export async function putBlob(hash: string, blob: Blob): Promise<void> {
  const d = await dir();
  if (!d) {
    mem.set(hash, blob);
    return;
  }
  const fh = await d.getFileHandle(hash, { create: true });
  const w = await fh.createWritable();
  await w.write(blob);
  await w.close();
}

export async function getBlob(hash: string): Promise<Blob | null> {
  const m = mem.get(hash);
  if (m) return m;
  const d = await dir();
  if (!d) return null;
  try {
    return await (await d.getFileHandle(hash)).getFile();
  } catch {
    return null;
  }
}

export async function removeBlob(hash: string): Promise<void> {
  mem.delete(hash);
  const d = await dir();
  if (d) await d.removeEntry(hash).catch(() => {});
}
